"use client";
import { patch } from "@n1ru4l/json-patch-plus";
import { useStore } from "@tanstack/react-store";
import Cookies from "js-cookie";
import { useEffect } from "react";
import type { z } from "zod/v4";
import hostInfo from "@/host.json";
import { getGameList } from "@/lib/game/api";
import { GameListSchema } from "@/lib/schema";
import { gameListStore } from "@/lib/store";

export function GameListProvider({
  initialData,
}: {
  initialData: {
    key: number;
    data: z.infer<typeof GameListSchema>;
  };
}) {
  const gameList = useStore(gameListStore);

  useEffect(() => {
    function handleResize() {
      const limit = 1024;
      const vw = window?.innerWidth;
      if (vw && vw < limit) {
        const hostname = location.hostname;

        const host = (hostInfo as Record<string, string>)[hostname];
        if (host) {
          console.info("host:", host);
          window.location.href = host;
        }
      }
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (document?.cookie) {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      Cookies.set("timeZone", timeZone);
    }
  }, []);

  useEffect(() => {
    gameListStore.setState({
      key: initialData.key,
      data: initialData.data,
    });
  }, [initialData]);

  useEffect(() => {
    const interval = setInterval(async () => {
      const result = await getGameList(gameList.key);

      let data: z.infer<typeof GameListSchema>;
      if (result?.key !== gameList.key && result?.data) {
        if (result.diff) {
          data = patch({
            left: gameList.data,
            delta: result.data,
          });
        } else {
          data = result.data as z.infer<typeof GameListSchema>;
        }

        gameListStore.setState({
          key: result.key,
          data: GameListSchema.parse(data),
        });
      }
    }, 1500);
    return () => clearInterval(interval);
  }, [gameList]);
  return null;
}
